import { prepHandleEvent } from "./prepHandleEvent";
import { EventToCanvas } from "./EventToCanvas";
export function handleRightClick(canvas) {
  return function (event) {
    if (event.target === canvas) {
      event.preventDefault();
    }
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas(event, rect.left, rect.top);

    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;

    myApp.HandleRightClick(p.x, p.y, event);
  };
}
